import React from 'react';

import { Grid, Popover, FormControlLabel, Checkbox } from "@material-ui/core";
import BCLButton from '../../../common/Buttons/BCLButton';

import { RECO_APPLIANCE_LIST_ICONS, EFFORT_LIST, COST_LIST, SELECT_ALL, WHOLE_HOME, WHOLE_HOME_ICON } from '../../../../constants/common';

export default function RecommendationsTipsDropdown(props) {
    const applianceList = props.recommendationsData.allowedAppliances;
    return (
        <Popover open={Boolean(props.recommendationsData.recoFilterDropdownEl)} onClose={() => props.onToggleFilterDropdown(null)} anchorEl={props.recommendationsData.recoFilterDropdownEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center'}}
            >
            <Grid className="reco-filter-dropdown">
                {props.recommendationsData.recoDropdownCheckboxAppliances && (
                    <Grid item xs={12} className="reco-filter-dropdown-left">
                        <p className="title">{props.translations["RECOMMENDATIONS.APPLIANCE_CATEGORY"]}</p>

                        {[SELECT_ALL, WHOLE_HOME].map(item => (
                            <div className="filter-categories-container" key={item}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={props.recommendationsData.recoDropdownCheckboxAppliances[item]} onChange={props.onApplianceCategoryCheckboxSelect.bind(this)} value={item} color="primary" name={item} classes={{colorPrimary: 'filter-checkboxes'}}/>
                                    }
                                    label={props.translations[`RECOMMENDATIONS.${item}`]} classes={{root: "filter-categories", label: (item === WHOLE_HOME && "filter-categories-label")}}
                                />
                                {/* Display icon for whole home only */}
                                {item === WHOLE_HOME && (
                                    <img src={WHOLE_HOME_ICON} alt={WHOLE_HOME} className="filter-icons" />
                                )}
                            </div>
                        ))}

                        {applianceList.map( (appliance, index) => (
                            <div className="filter-categories-container" key={index}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={props.recommendationsData.recoDropdownCheckboxAppliances[appliance]} onChange={props.onApplianceCategoryCheckboxSelect.bind(this)} value={appliance} color="primary" name={appliance} classes={{colorPrimary: 'filter-checkboxes'}}/>
                                    }
                                    label={props.appliancesList[appliance]} classes={{root: "filter-categories", label: "filter-categories-label"}}
                                />
                                <img src={RECO_APPLIANCE_LIST_ICONS[appliance]} alt={props.appliancesList[appliance]} className="filter-icons" />
                            </div>
                        ))}
                    </Grid>
                )}
                {/* <Grid item xs={6} className="reco-filter-dropdown-right">
                    <div>
                        <p className="title">Effort</p>
                        { EFFORT_LIST.map(effort => (
                            <FormControlLabel
                                control={
                                <Checkbox
                                    value={effort}
                                    color="primary"
                                    name={effort}
                                />
                                }
                                label={effort}
                                classes={{root: "filter-categories"}}
                            />
                        ))}
                    </div>
                    <br/>
                    <div>
                        <p className="title">Cost</p>
                        { COST_LIST.map(cost => {
                            return <FormControlLabel
                                control={
                                <Checkbox
                                    value={cost}
                                    color="primary"
                                    name={"cost-" + cost}
                                />
                                }
                                label={
                                    <>
                                        <span className="dollar">$</span>
                                        <span className="dollar">$</span>
                                        <span className="dollar">$</span>
                                        <span className="dollar">$</span>
                                        <span className="dollar">$</span>
                                        {cost === 1 ? " Low" : ""}
                                        {cost === 5 ? " High" : ""}
                                    </>
                                }
                                classes={{root: "filter-categories filter-categories-cost"}}
                            />
                        })}
                    </div>
                </Grid> */}
                <Grid item xs={12} className="reco-filter-dropdown-footer">
                    <BCLButton btnText={props.translations["RECOMMENDATIONS.TIPS.DRPOPDOWN.CANCEL"]} textColor={`rgb(${props.configColors['--color_1']})`} borderColor={`rgb(${props.configColors['--color_1']})`} hoverColor={`rgb(${props.configColors['--color_1']})`} hoverTextColor={`rgb(${props.configColors['--color_54']})`} cssClassName="cancel" onClick={() => props.onToggleFilterDropdown()} />
                    <BCLButton btnText={props.translations["RECOMMENDATIONS.TIPS.DRPOPDOWN.APPLY_FILTERS"]} textColor={`rgb(${props.configColors['--color_54']})`} borderColor={`rgb(${props.configColors['--color_1']})`} btnBackground={`rgb(${props.configColors['--color_1']})`} hoverColor={`rgb(${props.configColors['--color_1']})`} hoverTextColor={`rgb(${props.configColors['--color_54']})`} cssClassName="apply-filters" onClick={() => props.onApplyingFilters()}/>
                </Grid>
            </Grid>
        </Popover>
    )
}
